import routes from "@/lib/routes";
import styles from "@/styles/Video.module.scss";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef } from "react";

// 次話遷移カウントダウン15秒
const nextEpisodeDuration = 15000;

const checkFullScreen = () => {
  const fullScreenClass = document.getElementsByClassName("vjs-fullscreen");
  // fullscreenが有効な場合
  if (
    window.innerHeight == screen.height ||
    (fullScreenClass && fullScreenClass.length > 0)
  ) {
    return true;
  } else {
    return false;
  }
};

function ProgressCircle() {
  const circle = useRef();
  useEffect(() => {
    if (circle.current) {
      circle.current.style["stroke-dashoffset"] = 0;
    }
  }, [circle.current]);
  return (
    <div className={styles.progressCircle}>
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          r="45"
          cx="50"
          cy="50"
          fill="transparent"
          strokeDasharray="282.6"
          strokeDashoffset="0"
          strokeOpacity="0.5"
        ></circle>
        <circle
          ref={circle}
          r="45"
          cx="50"
          cy="50"
          fill="transparent"
          strokeDasharray="282.6"
          strokeDashoffset="0"
        ></circle>
      </svg>
    </div>
  );
}

export default function NextEpisode({ watch, state }) {
  const imageStyles = { borderRadius: "8px" };
  const { nextEpisode } = watch;
  const router = useRouter();

  const handleCancel = useCallback(() => {
    state.prepareSuspend();
  }, []);

  const isFullScreen = checkFullScreen();

  const pageTransition = useCallback(() => {
    if (!isFullScreen) {
      window.location.replace(routes.watch(nextEpisode.id));
    } else {
      router.replace(routes.watch(nextEpisode.id));
    }
  }, [isFullScreen]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      pageTransition();
    }, nextEpisodeDuration);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className={styles.nextEpisode}>
      <div>
        <div>
          <a onClick={pageTransition}>次のエピソードを見る</a>
        </div>
        <div className={styles.episode}>
          <div className={styles.episode}>
            <div className={styles.artwork}>
              {!!nextEpisode?.thumbnailUrl && (
                <Image
                  src={nextEpisode?.thumbnailUrl}
                  alt={nextEpisode?.name}
                  width={160}
                  height={90}
                  layout="responsive"
                  style={imageStyles}
                />
              )}
            </div>
          </div>
          <ProgressCircle />
        </div>
        <div className={styles.title}>
          <span>{nextEpisode?.name}</span>
        </div>
        <div>
          <a className={styles.cancel} onClick={handleCancel}>
            キャンセル
          </a>
        </div>
      </div>
    </div>
  );
}
